import { useMemo } from "react";

import type { ExpenseCategory } from "./reimbursementApi";

export const reimbursementFieldClass =
  "min-h-12 w-full rounded-md border border-slate-300 bg-white px-3 text-base text-slate-900";

export function YesNoField({
  label,
  value,
  onChange,
  disabled,
}: {
  label: string;
  value: boolean | null;
  onChange: (next: boolean) => void;
  disabled: boolean;
}): JSX.Element {
  return (
    <fieldset className="space-y-2">
      <legend className="text-sm font-medium text-slate-700">{label}</legend>
      <div className="grid grid-cols-2 gap-2">
        {([true, false] as const).map((option) => (
          <button
            key={option ? "yes" : "no"}
            type="button"
            disabled={disabled}
            className={`min-h-12 rounded-md border text-base font-medium ${
              value === option
                ? "border-brand-600 bg-brand-50 text-brand-800"
                : "border-slate-300 bg-white text-slate-800"
            }`}
            onClick={() => onChange(option)}
          >
            {option ? "Yes" : "No"}
          </button>
        ))}
      </div>
    </fieldset>
  );
}

export function CategorySelect({
  categories,
  value,
  onChange,
  disabled,
}: {
  categories: ExpenseCategory[];
  value: string;
  onChange: (next: string) => void;
  disabled: boolean;
}): JSX.Element {
  const groups = useMemo(() => {
    const order = ["Travel", "Trade Show", "General"] as const;
    return order.map((group) => ({
      group,
      rows: categories.filter((category) => category.group === group),
    }));
  }, [categories]);
  return (
    <label className="block space-y-1">
      <span className="text-sm font-medium text-slate-700">Category</span>
      <select
        className={reimbursementFieldClass}
        value={value}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
      >
        <option value="">Choose a category</option>
        {groups.map((group) => (
          <optgroup key={group.group} label={group.group}>
            {group.rows.map((category) => (
              <option key={category.key} value={category.key}>
                {category.hint ? `${category.label} (${category.hint})` : category.label}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
    </label>
  );
}
